"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("./Dialog"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const darkTheme = (0, _styles.createMuiTheme)({
  palette: {
    type: 'dark'
  }
});

const LayoutDialog = (_ref) => {
  let theme = _ref.theme,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["theme", "children"]);

  if (theme === "dark") {
    return _react.default.createElement(_styles.ThemeProvider, {
      theme: darkTheme
    }, _react.default.createElement(_Dialog.default, props, children));
  }

  return _react.default.createElement(_Dialog.default, props, children);
};

var _default = LayoutDialog;
exports.default = _default;
module.exports = exports.default;